var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('Header',{on:{"getlocal":_vm.getlocal}}):_vm._e(),_c('router-view'),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.hideHeader),expression:"!$route.meta.hideHeader"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }